import React, { useState, useEffect } from 'react';
import { adminApi } from '../helpers/adminApi';

const RelatedEventSelector = ({ value, onChange, currentEventId }) => {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);

  useEffect(() => {
    loadEvents();
  }, []);

  const loadEvents = async () => {
    try {
      setLoading(true);
      const data = await adminApi.fetchEntries('/api/events', {
        'sort[0]': 'newStartDate:desc',
        'populate': '*'
      });
      
      // Filter out current event and already selected events
      const filteredEvents = (data.data || []).filter(event => 
        event.documentId !== currentEventId
      );
      
      setEvents(filteredEvents);
    } catch (error) {
      console.error('Error loading events:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    setShowDropdown(true);
  };

  const handleAddEvent = (event) => {
    if (!value.find(selected => selected.documentId === event.documentId)) {
      onChange([...value, event]);
    }
    setSearchTerm('');
    setShowDropdown(false);
  };

  const handleRemoveEvent = (eventId) => {
    onChange(value.filter(event => event.documentId !== eventId));
  };

  const filteredEvents = events.filter(event => 
    event.title?.toLowerCase().includes(searchTerm.toLowerCase()) &&
    !value.find(selected => selected.documentId === event.documentId)
  );

  const formatDate = (dateString) => {
    if (!dateString) return '';
    return new Date(dateString).toLocaleDateString('fr-FR', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <div className="related-event-selector">
      {/* Selected events */}
      {value.length > 0 && (
        <div className="selected-events mb-3">
          <small className="text-muted">Événements sélectionnés :</small>
          <div className="mt-1">
            {value.map((event) => (
              <span key={event.documentId} className="badge bg-primary me-2 mb-1">
                {event.title}
                <button
                  type="button"
                  className="btn-close btn-close-white ms-2"
                  style={{ fontSize: '0.6rem' }}
                  onClick={() => handleRemoveEvent(event.documentId)}
                  aria-label="Supprimer"
                />
              </span>
            ))}
          </div>
        </div>
      )}

      {/* Search input */}
      <div className="position-relative">
        <input
          type="text"
          className="form-control"
          placeholder="Rechercher un événement à lier..."
          value={searchTerm}
          onChange={handleSearchChange}
          onFocus={() => setShowDropdown(true)}
        />
        
        {/* Dropdown */}
        {showDropdown && (
          <div className="dropdown-menu show position-absolute w-100" style={{ maxHeight: '200px', overflowY: 'auto', zIndex: 1000 }}>
            {loading ? (
              <div className="dropdown-item-text">
                <div className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
                Chargement...
              </div>
            ) : filteredEvents.length > 0 ? (
              filteredEvents.map((event) => (
                <button
                  key={event.documentId}
                  type="button"
                  className="dropdown-item"
                  onClick={() => handleAddEvent(event)}
                >
                  <div>
                    <strong>{event.title}</strong>
                    {event.newStartDate && (
                      <small className="text-muted d-block">
                        {formatDate(event.newStartDate)}
                      </small>
                    )}
                  </div>
                </button>
              ))
            ) : (
              <div className="dropdown-item-text text-muted">
                {searchTerm ? 'Aucun événement trouvé' : 'Tapez pour rechercher'}
              </div>
            )}
          </div>
        )}
      </div>

      {/* Click outside to close dropdown */}
      {showDropdown && (
        <div
          className="position-fixed"
          style={{ top: 0, left: 0, right: 0, bottom: 0, zIndex: 999 }}
          onClick={() => setShowDropdown(false)}
        />
      )}
    </div>
  );
};

export default RelatedEventSelector;